import React from 'react'
import { Layout } from 'antd'

type TAuthLayoutProps = {
  children?: any
}

const AuthLayout = ({ children }: TAuthLayoutProps) => {
  return (
    <Layout>
      <Layout.Content>
        <div>{children}</div>
      </Layout.Content>
    </Layout>
  )
}

export default AuthLayout
